import { FileDto } from '@ups/files';
import { RequestStatusEnum } from '@ups/xplat/core';

export interface IAddressChangeRequest {
  addressChangeRequestId: string;
  hrRef: number;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  requestDate: Date;
  RequestDate?: Date; // temp: need to figure out camelcase vs pascal case
  requestStatusId?: RequestStatusEnum;
  RequestStatusId?: RequestStatusEnum; // temp: need to figure out camelcase vs pascal case
  reviewedById?: number;
  reviewComment?: string;
  ReviewComment?: string;
  /**
   * @deprecated Use attachments property instead as since US-6524 we use multiple attachments now for address change request
   */
  fileId?: string;
  /**
   * @deprecated Use attachments property instead as since US-6524 we use multiple attachments now for address change request
   */
  fileName?: string;
  attachments: FileDto[];
  Attachments?: any[]; // temp: need to figure out camelcase vs pascal case
  requestStatusName?: string;
  country: string;
}
